module.exports = __webpack_public_path__ + "media/images/countryrect/gi-d703364379ef584ce028ef1522c37f1e.svg";